export interface SortFilterOption<T extends string> {
  value: T
  label: string
  enabled: boolean
}

export interface ProductionSortFilterType {
  sortOption: SortFilterOption<server.dto.TourSort>
}

export const DefaultProductionSortFilter: server.dto.TourSort = "date_asc";

export const ProductionSortOptions: Array<SortFilterOption<server.dto.TourSort>> = [
  {
    label: RESX.DateTime.lblDate,
    value: "date_asc",
    enabled: true
  },
  {
    label: RESX.GeneralLabels.Name,
    value: "name_asc",
    enabled: true
  }
];

export const getSortOption = (value: server.dto.TourSort) => {
  return ProductionSortOptions.find(s => s.value === value);
};

export const initialProductionSortFilter: ProductionSortFilterType = {
  sortOption: getSortOption(DefaultProductionSortFilter)
};
